import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	teamworkCollectionGroupLabel: {
		id: 'people-and-team.invite-people.form.teamwork-collection-group-label',
		defaultMessage: 'Teamwork Collection',
		description: 'Label for the Teamwork Collection',
	},
	teamworkCollectionGroupTooltipJira: {
		id: 'people-and-team.invite-people.form.teamwork-collection-group-tooltip-jira',
		defaultMessage: 'With Teamwork Collection, they can also access Confluence and Loom for free.',
		description:
			'Tooltip message to explain Teamwork Collection licensing when viewing the grouping on Jira',
	},
	teamworkCollectionGroupTooltipConfluence: {
		id: 'people-and-team.invite-people.form.teamwork-collection-group-tooltip-confluence',
		defaultMessage: 'With Teamwork Collection, they can also access Jira and Loom for free.',
		description:
			'Tooltip message to explain Teamwork Collection licensing when viewing the grouping on Confluence',
	},
	defaultGroupLabel: {
		id: 'people-and-team.invite-people.form.tooltip-group-label',
		defaultMessage: 'Other apps',
		description: 'Label for all other apps',
	},
});
